import React, {useCallback, useState, useEffect} from 'react';
import {message} from 'antd'
import {useParams, useNavigate} from 'react-router-dom'

import BaseEdit from "./base.edit"
import BaseInfo from './base.info'
import Catalogue from "./catalogue/index";
import Api from '../../api'
import {emptyValidate} from "../../util/validate";

export default function CourseSeries() {
  const navigate = useNavigate();
  const params = useParams();
  const [infoEdit, setInfoEdit] = useState(!params.id)
  const [baseInfo, setBaseInfo] = useState({})
  const [lecturerList, setlecturerList] = useState([])

  const [courseId, setCourseId] = useState(params.id)

  useEffect(()=>{
    if (params.id) {
      setCourseId(params.id)
      Api.getCourseInfo(params.id).then(resp=>{
        setBaseInfo(resp.info.course)
        setlecturerList(resp.info.lecturerList)
      })
    } else {
      setInfoEdit(true)
      setBaseInfo({})
      setlecturerList([])
      setCourseId()
    }
  },[params.id])

  const createCourse = useCallback((baseInfo, lecturerList)=>{
    let validateResult = emptyValidate(baseInfo.courseName, '请填写课程名称')
        || emptyValidate(baseInfo.coverImg, '请上传课程封面');

    if (validateResult) {
      return;
    }
    let data = {
      ...baseInfo,
      courseId:params.id,
      typeCode:1
    }
    data.label = data.labels.join('|')

    setBaseInfo(data)
    setlecturerList(lecturerList)
    Api.createUpdateCourse(data).then(resp=>{
      if (resp.resultCode ===1) {
        message.success(resp.resultMessage)
        if (!params.id) {
          setInfoEdit(false)
          navigate('/course/series/'+resp.info)
        } else {
          setInfoEdit(false)
        }
      }
    })
  })

  const editBaseInfo = useCallback(()=>{
    setInfoEdit(true)
  })

  const cancel = useCallback(()=>{
    if (courseId) {
      setInfoEdit(false)
    } else {
      navigate('/course/list');
    }
  })

  return <>
    {!infoEdit && <BaseInfo data={baseInfo} lecturerList={lecturerList} courseId={courseId} onEdit={editBaseInfo}/>}
    {infoEdit && <BaseEdit onSave={createCourse} onCancel={cancel} data={baseInfo} lecturerList={lecturerList} />}
    {!infoEdit && <Catalogue courseId={params.id}/>}
  </>
}




